import { DEPOSIT_ROOT } from '@mobi/account/Areas/Deposit/Utils/routes'
import { routes as depositLimitRoutes } from '@mobi/account/Areas/DepositLimit/Utils/routes'
import { REVERIFICATION_ROOT_ROUTE } from '@mobi/account/Areas/Reverification/Utils'
import { SIGNUP_ROOT_ROUTE } from '@mobi/account/Areas/SignUp/Utils'
import { ACTIVITY_STATEMENTS_ROUTE } from '@mobi/account/Areas/Statements/Utils/constants'
import { routes as accountRoutes } from '@mobi/account/Utils'
import { SHORTENED_URL_ROUTE } from '@core/Areas/ShortenedUrls/constants'
import { ACCOUNT_ACTIVITY_ROUTE } from './Areas/Account/Pages/Activity/constants'
import { CHANGE_TEMP_PASSWORD_ROUTE } from './Areas/ChangePassword/constants'
import { KAMBI_ROOT_ROUTE } from './Areas/KambiClient/constants'
import { TABLocatorWebRoute } from './Areas/TABLocatorWeb/constants'

type RoutePath = `/${string}`
type AppRoutesPath = Readonly<RoutePath | RoutePath[]>

export const AppRoutes = {
  Home: '/',

  Account: '/account',
  AccountActivity: `/${ACCOUNT_ACTIVITY_ROUTE}/:tab?`,
  AccountLogout: '/account/logout',
  BankAccountEdit: '/account/bankaccount/edit',
  Biometrics: '/account/biometrics',
  Blackbook: '/account/blackbook',
  BlockDebitCard: accountRoutes.blockDebitCard,
  BonusOffers: '/account/offer',
  ChangePassword: '/account/change-password',
  ChangeTemporaryPassword: `/${CHANGE_TEMP_PASSWORD_ROUTE}/:accountNumber`,
  CloseAccount: '/account/close',
  MarketingCommunications: '/account/marketingcommunications',
  MarketingCommunicationsOptIn: '/account/marketingcommunications/optin',
  MyBets: '/account/my-bets/:tab',
  Precommitment: '/account/precommitment',
  Settings: '/account/settings',
  SettingsMFA: '/account/settings/mfa',
  Statements: `/${ACTIVITY_STATEMENTS_ROUTE}`,
  TakeABreak: '/account/take-a-break',

  ContactUs: '/contactus',
  Deposit: DEPOSIT_ROOT,
  DepositLimits: depositLimitRoutes.editDepositLimit,
  FavouriteNumbers: '/favourite-numbers',
  BetLoop: '/bet-loop',
  BetLoopProfile: '/bet-loop/profile',
  BetLoopMyProfile: '/bet-loop/my-profile',
  BetLoopMyProfileFollowList: '/bet-loop/my-profile/follow-list',
  BetLoopSearchProfiles: '/bet-loop/search',
  GoodThings: '/goodthings',
  Jackpots: '/jackpots',
  Meetings: '/tote',
  MysteryBet: '/tote/mystery/:meetingId?/:raceNumber?',
  NextEvents: '/next-events',
  RaceCard: '/tote/meetings/:meetingId/:raceNumber',
  RaceCardFixedOnly: '/fobracing/propositions/:product/:code/:raceId/:selectiondate?',
  RaceCardSky: '/live-sky-race',
  RaceEvents: '/fobracing/:product/:code/:date?',
  RaceList: '/tote/races',
  RaceListForMeeting: '/tote/meetings/:meetingId',
  Reverification: `/${REVERIFICATION_ROOT_ROUTE}`,
  Search: '/search',
  SignUp: `/${SIGNUP_ROOT_ROUTE}`,
  Specials: '/specials',
  /** Kambi Sports Offering Integration */
  Sports: '/sports',
  SportsRoot: `/${KAMBI_ROOT_ROUTE}`,
  StructuredSearch: '/smart-form',
  ShortenedUrls: `/${SHORTENED_URL_ROUTE}`,
  TABLocatorWeb: `/${TABLocatorWebRoute}`,
  Tipping: '/totesports',
  Toolbox: '/toolbox',
  VenueMode: '/venue-mode',
} as const

export const RACES_ROUTES: AppRoutesPath[] = [
  AppRoutes.Blackbook,
  AppRoutes.BonusOffers,
  AppRoutes.FavouriteNumbers,
  AppRoutes.GoodThings,
  AppRoutes.Jackpots,
  AppRoutes.Meetings,
  AppRoutes.MysteryBet,
  AppRoutes.NextEvents,
  AppRoutes.RaceCardFixedOnly,
  AppRoutes.RaceEvents,
  AppRoutes.RaceList,
  AppRoutes.Specials,
  AppRoutes.StructuredSearch,
  AppRoutes.Tipping,
]
